import { Action } from 'redux'

import { File } from '../../lib/interfaces/File.interface'
import { Pagination } from '../../lib/interfaces/Pagination.interface'
import { CountByType } from '../../lib/interfaces/CountByType.interface'
import { JobApplicant } from '../../lib/interfaces/JobApplicant.interface'
import { LocationJobPosition } from '../../lib/interfaces/JobPosition.interface'
import { ApplicationStatus } from '../../lib/interfaces/ApplicationStatus.interface'
import { JobApplicantComment } from '../../lib/interfaces/JobApplicantComment.interface'
import { ApplicationFilterParameters } from '../../lib/interfaces/ApplicationFilterParameters.interface'

import { ApplicationUpdateRequest } from '../../lib/api/applications'

export const actionTypes = {
  APPLICATIONS_FETCH: 'APPLICATIONS_FETCH',
  APPLICATIONS_FETCH_FAILED: 'APPLICATIONS_FETCH_FAILED',
  APPLICATIONS_FETCH_SUCCESS: 'APPLICATIONS_FETCH_SUCCESS',

  APPLICATIONS_FETCH_FILES: 'APPLICATIONS_FETCH_FILES',
  APPLICATIONS_FETCH_FILES_FAILED: 'APPLICATIONS_FETCH_FILES_FAILED',
  APPLICATIONS_FETCH_FILES_SUCCESS: 'APPLICATIONS_FETCH_FILES_SUCCESS',

  APPLICATIONS_UPLOAD_FILE: 'APPLICATIONS_UPLOAD_FILE',
  APPLICATIONS_UPLOAD_FILE_SUCCESS: 'APPLICATIONS_UPLOAD_FILE_SUCCESS',
  APPLICATIONS_UPLOAD_FILE_FAILED: 'APPLICATIONS_UPLOAD_FILE_FAILED',

  APPLICATIONS_FETCH_LOCATION_JOB_POSITIONS_LIST: 'APPLICATIONS_FETCH_LOCATION_JOB_POSITIONS_LIST',
  APPLICATIONS_FETCH_LOCATION_JOB_POSITIONS_LIST_FAILED: 'APPLICATIONS_FETCH_LOCATION_JOB_POSITIONS_LIST_FAILED',
  APPLICATIONS_FETCH_LOCATION_JOB_POSITIONS_LIST_SUCCESS: 'APPLICATIONS_FETCH_LOCATION_JOB_POSITIONS_LIST_SUCCESS',

  APPLICATIONS_UPDATE_LOCATION_JOB_POSITION_OPEN: 'APPLICATIONS_UPDATE_LOCATION_JOB_POSITION_OPEN',
  APPLICATIONS_UPDATE_LOCATION_JOB_POSITION_OPEN_FAILED: 'APPLICATIONS_UPDATE_LOCATION_JOB_POSITION_OPEN_FAILED',
  APPLICATIONS_UPDATE_LOCATION_JOB_POSITION_OPEN_SUCCESS: 'APPLICATIONS_UPDATE_LOCATION_JOB_POSITION_OPEN_SUCCESS',

  APPLICATIONS_FETCH_LIST: 'APPLICATIONS_FETCH_LIST',
  APPLICATIONS_FETCH_LIST_FAILED: 'APPLICATIONS_FETCH_LIST_FAILED',
  APPLICATIONS_FETCH_LIST_SUCCESS: 'APPLICATIONS_FETCH_LIST_SUCCESS',

  APPLICATIONS_FETCH_SUMMARY: 'APPLICATIONS_FETCH_SUMMARY',
  APPLICATIONS_FETCH_SUMMARY_FAILED: 'APPLICATIONS_FETCH_SUMMARY_FAILED',
  APPLICATIONS_FETCH_SUMMARY_SUCCESS: 'APPLICATIONS_FETCH_SUMMARY_SUCCESS',

  APPLICATIONS_POST_COMMENT: 'APPLICATIONS_POST_COMMENT',
  APPLICATIONS_POST_COMMENT_FAILED: 'APPLICATIONS_POST_COMMENT_FAILED',
  APPLICATIONS_POST_COMMENT_SUCCESS: 'APPLICATIONS_POST_COMMENT_SUCCESS',

  APPLICATIONS_UPDATE_STATUS: 'APPLICATIONS_UPDATE_STATUS',
  APPLICATIONS_UPDATE_STATUS_FAILED: 'APPLICATIONS_UPDATE_STATUS_FAILED',
  APPLICATIONS_UPDATE_STATUS_SUCCESS: 'APPLICATIONS_UPDATE_STATUS_SUCCESS',

  APPLICATIONS_APPROVE: 'APPLICATIONS_APPROVE',
  APPLICATIONS_APPROVE_FAILED: 'APPLICATIONS_APPROVE_FAILED',
  APPLICATIONS_APPROVE_SUCCESS: 'APPLICATIONS_APPROVE_SUCCESS',

  APPLICATIONS_CONVERT_TO_EMPLOYEE: 'APPLICATIONS_CONVERT_TO_EMPLOYEE',
  APPLICATIONS_CONVERT_TO_EMPLOYEE_FAILED: 'APPLICATIONS_CONVERT_TO_EMPLOYEE_FAILED',
  APPLICATIONS_CONVERT_TO_EMPLOYEE_SUCCESS: 'APPLICATIONS_CONVERT_TO_EMPLOYEE_SUCCESS',

  APPLICATIONS_FETCH_NEXT_EMPLOYEE_ID: 'APPLICATIONS_FETCH_NEXT_EMPLOYEE_ID',
  APPLICATIONS_FETCH_NEXT_EMPLOYEE_ID_FAILED: 'APPLICATIONS_FETCH_NEXT_EMPLOYEE_ID_FAILED',
  APPLICATIONS_FETCH_NEXT_EMPLOYEE_ID_SUCCESS: 'APPLICATIONS_FETCH_NEXT_EMPLOYEE_ID_SUCCESS',

  APPLICATIONS_SET_FILTER_PARAMS: 'APPLICATIONS_SET_FILTER_PARAMS',

  APPLICATIONS_UPDATE: 'APPLICATIONS_UPDATE',
  APPLICATIONS_UPDATE_FAILED: 'APPLICATIONS_UPDATE_FAILED',
  APPLICATIONS_UPDATE_SUCCESS: 'APPLICATIONS_UPDATE_SUCCESS'
}

/**
 * Fetch single application
 */
export interface ApplicationsFetchApplicationAction extends Action {
  payload: {
    applicationId: string
    next?: (err?: any, application?: JobApplicant) => void
  }
}

export const fetchApplication = (applicationId: string, next?: (err?: any, application?: JobApplicant) => void): ApplicationsFetchApplicationAction => ({
  type: actionTypes.APPLICATIONS_FETCH,
  payload: { next, applicationId}
})

// Success
export interface ApplicationsFetchApplicationSuccessAction extends Action {
  payload: {
    application: JobApplicant
  }
}

export const fetchApplicationSuccess = (application: JobApplicant): ApplicationsFetchApplicationSuccessAction => ({
  type: actionTypes.APPLICATIONS_FETCH_SUCCESS,
  payload: { application }
})

// Error
export interface ApplicationsFetchApplicationErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchApplicationError = (errorMessage?: string): ApplicationsFetchApplicationErrorAction => ({
  type: actionTypes.APPLICATIONS_FETCH_FAILED,
  payload: { errorMessage }
})

/**
 * Fetch application files
 */
export interface ApplicationsFetchFilesAction extends Action {
  payload: {
    applicationId: string
    next?: (err?: any, files?: File[]) => void
  }
}

export const fetchApplicationFiles = (applicationId: string, next?: (err?: any, files?: File[]) => void): ApplicationsFetchFilesAction => ({
  type: actionTypes.APPLICATIONS_FETCH_FILES,
  payload: { next, applicationId }
})

// Success
export interface ApplicationsFetchFilesSuccessAction extends Action {
  payload: {
    files: File[]
    applicationId: string
  }
}

export const fetchApplicationFilesSuccess = (files: File[], applicationId: string): ApplicationsFetchFilesSuccessAction => ({
  type: actionTypes.APPLICATIONS_FETCH_FILES_SUCCESS,
  payload: { files, applicationId }
})

// Error
export interface ApplicationsFetchFilesErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchApplicationFilesError = (errorMessage?: string): ApplicationsFetchFilesErrorAction => ({
  type: actionTypes.APPLICATIONS_FETCH_FILES_FAILED,
  payload: { errorMessage }
})

/*
 * Upload application file
 */
export interface ApplicationsUploadFileAction extends Action {
  payload: {
    file: any
    applicationId: string
    next?: (err?: any, file?: File) => void
  }
 }
 
 export const uploadApplicationFile = (applicationId: string, file: any, next?: (err?: any, file?: File) => void): ApplicationsUploadFileAction => ({
  type: actionTypes.APPLICATIONS_UPLOAD_FILE,
  payload: { file, next, applicationId }
 })
 
 // Success
 export const uploadApplicationFileSuccess = (): Action => ({
  type: actionTypes.APPLICATIONS_UPLOAD_FILE_SUCCESS
 })
 
 // Error
 export interface ApplicationsUploadFileErrorAction extends Action {
   payload: {
     errorMessage: string
   }
 }
 
 export const uploadApplicationFileError = (errorMessage: string): ApplicationsUploadFileErrorAction => ({
   type: actionTypes.APPLICATIONS_UPLOAD_FILE_FAILED,
   payload: { errorMessage }
 })

/**
 * Fetch job location positions
 */
export interface ApplicationsFetchLocationJobPositionsListAction extends Action {
  payload: {
    next?: () => void
  }
}

export const fetchJobLocationPositionsList = (next?: () => void): ApplicationsFetchLocationJobPositionsListAction => ({
  type: actionTypes.APPLICATIONS_FETCH_LOCATION_JOB_POSITIONS_LIST,
  payload: { next }
})

// Success
export interface ApplicationsFetchLocationJobPositionsListSuccessAction extends Action {
  payload: {
    locationJobPositions: LocationJobPosition[]
  }
}

export const fetchLocationJobPositionsListSuccess = (locationJobPositions: LocationJobPosition[]): ApplicationsFetchLocationJobPositionsListSuccessAction => ({
  type: actionTypes.APPLICATIONS_FETCH_LOCATION_JOB_POSITIONS_LIST_SUCCESS,
  payload: { locationJobPositions }
})

// Error
export interface ApplicationsFetchLocationJobPositionsListErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchLocationJobPositionsListError = (errorMessage?: string): ApplicationsFetchLocationJobPositionsListErrorAction => ({
  type: actionTypes.APPLICATIONS_FETCH_LOCATION_JOB_POSITIONS_LIST_FAILED,
  payload: { errorMessage }
})

/**
 * Update job location position open
 */
export interface ApplicationsUpdateLocationJobPositionOpenAction extends Action {
  payload: {
    open: boolean
    next?: () => void
    locationJobPositionId: number
  }
}

export const updateLocationJobPositionOpen = (locationJobPositionId: number, open: boolean, next?: () => void): ApplicationsUpdateLocationJobPositionOpenAction => ({
  type: actionTypes.APPLICATIONS_UPDATE_LOCATION_JOB_POSITION_OPEN,
  payload: { next, open, locationJobPositionId }
})

// Success
export interface ApplicationsUpdateLocationJobPositionOpenSuccessAction extends Action {
  payload: {
    open: boolean,
    locationJobPositionId: number
  }
}

export const updateLocationJobPositionOpenSuccess = (locationJobPositionId: number, open: boolean): ApplicationsUpdateLocationJobPositionOpenSuccessAction => ({
  type: actionTypes.APPLICATIONS_UPDATE_LOCATION_JOB_POSITION_OPEN_SUCCESS,
  payload: { open, locationJobPositionId }
})

// Error
export interface ApplicationsUpdateLocationJobPositionOpenErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const updateLocationJobPositionOpenError = (errorMessage?: string): ApplicationsUpdateLocationJobPositionOpenErrorAction => ({
  type: actionTypes.APPLICATIONS_UPDATE_LOCATION_JOB_POSITION_OPEN_FAILED,
  payload: { errorMessage }
})

/**
 * Fetch applications list
 */
export interface ApplicationsFetchListAction extends Action {
  payload: {
    next?: (err?: any, applications?: Pagination<JobApplicant>) => void
  }
}

export const fetchApplicationsList = (next?: (err?: any, applications?: Pagination<JobApplicant>) => void): ApplicationsFetchListAction => ({
  type: actionTypes.APPLICATIONS_FETCH_LIST,
  payload: { next }
})

// Success
export interface ApplicationsFetchListSuccessAction extends Action {
  payload: {
    paginatedApplications: Pagination<JobApplicant>
  }
}

export const fetchApplicationsListSuccess = (paginatedApplications: Pagination<JobApplicant>): ApplicationsFetchListSuccessAction => ({
  type: actionTypes.APPLICATIONS_FETCH_LIST_SUCCESS,
  payload: { paginatedApplications }
})

// Error
export interface ApplicationsFetchListErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchApplicationsListError = (errorMessage?: string):ApplicationsFetchListErrorAction => ({
  type: actionTypes.APPLICATIONS_FETCH_LIST_FAILED,
  payload: { errorMessage }
})

/**
 * Fetch applications summary
 */
export interface ApplicationsFetchSummaryAction extends Action {
  payload: {
    next?: (err?: any, summary?: CountByType[]) => void
  }
}

export const fetchApplicationsSummary = (next?: (err?: any, summary?: CountByType[]) => void): ApplicationsFetchSummaryAction => ({
  type: actionTypes.APPLICATIONS_FETCH_SUMMARY,
  payload: { next }
})

// Success
export interface ApplicationsFetchSummarySuccessAction extends Action {
  payload: {
    summary: CountByType[]
  }
}

export const fetchApplicationsSummarySuccess = (summary: CountByType[]): ApplicationsFetchSummarySuccessAction => ({
  type: actionTypes.APPLICATIONS_FETCH_SUMMARY_SUCCESS,
  payload: { summary }
})

// Error
export interface ApplicationsFetchSummaryErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchApplicationsSummaryError = (errorMessage?: string): ApplicationsFetchSummaryErrorAction => ({
  type: actionTypes.APPLICATIONS_FETCH_SUMMARY_FAILED,
  payload: { errorMessage }
})

/**
 * Post application comment
 */
export interface ApplicationsPostCommentAction extends Action {
  payload: {
    comment: string
    applicationId: string
    next?: (err?: any, comment?: JobApplicantComment) => void
  }
}

export const postApplicationComment = (applicationId: string, comment: string, next?: (err?: any, comment?: JobApplicantComment) => void): ApplicationsPostCommentAction => ({
  type: actionTypes.APPLICATIONS_POST_COMMENT,
  payload: { next, comment, applicationId }
})

// Success
export interface ApplicationsPostCommentSuccessAction extends Action {
  payload: {
    applicationId: string
    comment: JobApplicantComment
  }
}

export const postApplicationCommentSuccess = (applicationId: string, comment: JobApplicantComment): ApplicationsPostCommentSuccessAction => ({
  type: actionTypes.APPLICATIONS_POST_COMMENT_SUCCESS,
  payload: { comment, applicationId }
})

// Error
export interface ApplicationsPostCommentErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const postApplicationCommentError = (errorMessage?: string): ApplicationsPostCommentErrorAction => ({
  type: actionTypes.APPLICATIONS_POST_COMMENT_FAILED,
  payload: { errorMessage }
})

/**
 * Update application status
 */
export interface ApplicationsUpdateStatusAction extends Action {
  payload: {
    applicationId: string
    status: ApplicationStatus
    next?: (err?: any, application?: JobApplicant) => void
  }
}

export const updateApplicationStatus = (applicationId: string, status: ApplicationStatus, next?: (err?: any, application?: JobApplicant) => void): ApplicationsUpdateStatusAction => ({
  type: actionTypes.APPLICATIONS_UPDATE_STATUS,
  payload: { next, status, applicationId }
})

// Success
export interface ApplicationsUpdateStatusSuccessAction extends Action {
  payload: {
    application: JobApplicant
  }
}

export const updateApplicationStatusSuccess = (application: JobApplicant): ApplicationsUpdateStatusSuccessAction => ({
  type: actionTypes.APPLICATIONS_UPDATE_STATUS_SUCCESS,
  payload: { application }
})

// Error
export interface ApplicationsUpdateStatusErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const updateApplicationStatusError = (errorMessage?: string): ApplicationsUpdateStatusErrorAction => ({
  type: actionTypes.APPLICATIONS_UPDATE_STATUS_FAILED,
  payload: { errorMessage }
})

/**
 * Approve application
 */
export interface ApplicationsApproveAction extends Action {
  payload: {
    applicationId: string
    next?: (err?: any, application?: JobApplicant) => void
  }
}

export const approveApplication = (applicationId: string, next?: (err?: any, application?: JobApplicant) => void) => ({
  type: actionTypes.APPLICATIONS_APPROVE,
  payload: { applicationId, next }
})

// Success
export interface ApplicationsApproveSuccessAction extends Action {
  payload: {
    application: JobApplicant
  }
}

export const approveApplicationSuccess = (application: JobApplicant): ApplicationsApproveSuccessAction => ({
  type: actionTypes.APPLICATIONS_APPROVE_SUCCESS,
  payload: { application }
})

// Error
export interface ApplicationsApproveErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const approveApplicationError = (errorMessage?: string): ApplicationsApproveErrorAction => ({
  type: actionTypes.APPLICATIONS_APPROVE_FAILED,
  payload: { errorMessage }
})

/**
 * Convert applicant to employee
 */
export interface ApplicationsConvertToEmployeeAction extends Action {
  payload: {
    employeeId: string
    applicationId: string
    next?: (err?: any, application?: JobApplicant) => void
  }
}

export const convertApplicationToEmployee = (applicationId: string, employeeId: string, next?: (err?: any, application?: JobApplicant) => void): ApplicationsConvertToEmployeeAction => ({
  type: actionTypes.APPLICATIONS_CONVERT_TO_EMPLOYEE,
  payload: { next, employeeId, applicationId }
})

// Success
export interface ApplicationsConvertToEmployeeSuccessAction extends Action {
  payload: {
    application: JobApplicant
  }
}

export const convertApplicationToEmployeeSuccess = (application: JobApplicant): ApplicationsConvertToEmployeeSuccessAction => ({
  type: actionTypes.APPLICATIONS_CONVERT_TO_EMPLOYEE_SUCCESS,
  payload: { application }
})

// Error
export interface ApplicationsConvertToEmployeeErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const convertApplicationToEmployeeError = (errorMessage: string): ApplicationsConvertToEmployeeErrorAction => ({
  type: actionTypes.APPLICATIONS_CONVERT_TO_EMPLOYEE_FAILED,
  payload: { errorMessage }
})

/**
 * Fetch next employee id
 */
export interface ApplicationsFetchNextEmployeeIdAction extends Action {
  payload: {
    next?: (err?: any, nextEmployeeId?: string) => void
  }
}

export const fetchNextEmployeeId = (next?: (err?: any, nextEmployeeId?: string) => void): ApplicationsFetchNextEmployeeIdAction => ({
  type: actionTypes.APPLICATIONS_FETCH_NEXT_EMPLOYEE_ID,
  payload: { next }
})

// Success
export interface ApplicationsFetchNextEmployeeIdSuccessAction extends Action {
  payload: {
    nextEmployeeId: string
  }
}

export const fetchNextEmployeeIdSuccess = (nextEmployeeId: string): ApplicationsFetchNextEmployeeIdSuccessAction => ({
  type: actionTypes.APPLICATIONS_FETCH_NEXT_EMPLOYEE_ID_SUCCESS,
  payload: { nextEmployeeId }
})

// Error
export interface ApplicationsFetchNextEmployeeIdErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchNextEmployeeIdError = (errorMessage?: string): ApplicationsFetchNextEmployeeIdErrorAction => ({
  type: actionTypes.APPLICATIONS_FETCH_NEXT_EMPLOYEE_ID_FAILED,
  payload: { errorMessage }
})

/**
 * Update filter params
 */
export interface ApplicationsSetFilterParamsAction extends Action {
  payload: {
    filterParams: ApplicationFilterParameters
  }
}

export const setApplicationsFilterParams = (filterParams: ApplicationFilterParameters): ApplicationsSetFilterParamsAction => ({
  type: actionTypes.APPLICATIONS_SET_FILTER_PARAMS,
  payload: { filterParams }
})

/**
 * Update application
 */
export interface ApplicationsUpdateAction extends Action {
  payload: {
    applicationId: string
    application: ApplicationUpdateRequest
    next?: (err?: any, application?: JobApplicant) => void
  }
}

export const updateApplication = (applicationId: string, application: ApplicationUpdateRequest, next?: (err?: any, application?: JobApplicant) => void): ApplicationsUpdateAction => ({
  type: actionTypes.APPLICATIONS_UPDATE,
  payload: { next, application, applicationId}
})

// Success
export interface ApplicationsUpdateSuccessAction extends Action {
  payload: {
    application: JobApplicant
  }
}

export const updateApplicationSuccess = (application: JobApplicant): ApplicationsUpdateSuccessAction => ({
  type: actionTypes.APPLICATIONS_UPDATE_SUCCESS,
  payload: { application }
})

// Error
export interface ApplicationsUpdateErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const updateApplicationError = (errorMessage?: string): ApplicationsUpdateErrorAction => ({
  type: actionTypes.APPLICATIONS_UPDATE_FAILED,
  payload: { errorMessage }
})

/**
 * Action Types
 */
export type ActionTypes = ApplicationsFetchLocationJobPositionsListAction | ApplicationsUpdateLocationJobPositionOpenAction



// WEBPACK FOOTER //
// ./src/store/applications/actions.ts